'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

exports.createRenderer = createRenderer;

var _attributes = require('./attributes');

var _observer = require('./observer');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createRenderer(_ref) {
    var appnexus = _ref.appnexus,
        placementFactory = _ref.placementFactory;
    // eslint-disable-line import/prefer-default-export
    var adsState = {};
    var getAdById = function getAdById(id) {
        return adsState[id];
    };

    return {
        register: function register(node, callbacks) {
            var placementId = (0, _attributes.getId)(node);
            var placement = getAdById(placementId);

            if (!placement) {
                placement = placementFactory(node);
                adsState[placementId] = placement;

                appnexus.loadTags();
            }

            return callbacks ? placement.subscribe(callbacks) : undefined;
        },
        unregister: function unregister(node) {
            var placementId = (0, _attributes.getId)(node);
            var placement = getAdById(placementId);

            if (placement) {
                placement.destroy();

                adsState = (0, _keys2.default)(adsState).filter(function (id) {
                    return id !== placementId;
                }).reduce(function (acc, id) {
                    acc[id] = adsState[id]; // eslint-disable-line  no-param-reassign
                    return acc;
                }, {});
            }
        },

        setPageOptions: appnexus.setPageOptions,
        updatePlacements: _observer.forceUpdate
    };
}
//# sourceMappingURL=renderer.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ad-renderer/lib/renderer.js
 ** module id = 468
 ** module chunks = 1
 **/